function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22 0v44",
  stroke: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M44 22H0",
  stroke: "#fff"
});

function SvgPlusSymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyIDBMMjIgNDQiIHN0cm9rZT0id2hpdGUiLz4KPHBhdGggZD0iTTQ0IDIyTC0xLjQzMDUxZS0wNiAyMiIgc3Ryb2tlPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgPlusSymbol as ReactComponent };